"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.getRules = getRules;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/rule',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/rule/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/rule',
    method: 'put',
    data: data
  });
}

function getRules(params) {
  return (0, _request.default)({
    url: 'api/rule/all',
    method: 'get',
    params: params
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  getRules: getRules
};
exports.default = _default;